import React, { useContext, useState } from 'react';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import {
  FINISHED,
  URL_STATUS,
  ENVIRONMENTS,
  REGIONS_DATASOURCE_UNDERSCORE,
  FILTER_NAME_TO_PARAM,
  FAVORITES_FILTER,
} from '../../Constants/constants';
import './TestExecutions.css';
import Rerun from './TestExecutionsActions/Rerun';
import See from './TestExecutionsActions/See';
import Favorites from './TestExecutionsActions/Favorites';
import Cancel from './TestExecutionsActions/Cancel';
import { AppContext } from '../UI/contexts';
import ChildExecutions from './TestExecutionsActions/ChildExecutions';
import OtherOptionsMenu from './TestExecutionsActions/OtherOptionsMenu';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { Dropdown } from 'primereact/dropdown';
import { Tooltip } from 'primereact/tooltip';
import 'primereact/resources/primereact.css';
import { Paginator } from 'primereact/paginator';
import { useQuery } from '@apollo/client';
import { GET_CUSTOMERS_DATA } from '../../GraphQL/TestExecutions/TRFX/Queries';
import './TestExecutionsTable.css';

function TestExecutionsTable({
  data,
  isScheduled,
  perPage,
  itemCount,
  isATCTable,
  editRoute,
  seeTestResultsHandler,
  addToFavoritesHandler,
  removeFromFavoritesHandler,
  cancelExecutionHandler,
  deleteSingleClickHandler,
  rerunSingleClickHandler,
  scheduleSingleClickHandler,
  refetch,
  refetchVariables,
  filterVariables,
  setSelectedToSchedule,
}) {
  // const filters = useRef(filterVariables);
  const [filters, setFilters] = useState({
    executionStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    env: { value: null, matchMode: FilterMatchMode.EQUALS },
    region: { value: null, matchMode: FilterMatchMode.EQUALS },
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    isFavourite: { value: null, matchMode: FilterMatchMode.EQUALS },
    clients: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const { user } = useContext(AppContext);
  const roles = user.roles.map((role) => role.name);
  const isAdmin = roles.includes('admin');

  function testResultsTemplate(props) {
    if (props.status === FINISHED) {
      return (
        <div
          className={`${props.executionStatus} justify-content-center d-flex`}
        >
          {props.executionStatus}
        </div>
      );
    }
    return <div className='justify-content-center d-flex'>---</div>;
  }

  function nameTemplate(props) {
    return (
      <div className='d-flex'>
        <div
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {props.name}
        </div>
        <div className='ml-auto'>
          <button
            className='att-description'
            data-pr-tooltip={props.description || 'No description available'}
            data-pr-position='top'
          >
            <IoMdInformationCircleOutline
              id={props.id}
              size={15}
              className=''
              color='var(--att-primary)'
            />
          </button>
          <Tooltip target='.att-description' />
        </div>
      </div>
    );
  }

  function clientsTemplate(props) {
    if (!props.clients || props.clients === undefined) {
      return <div style={{ color: '#999' }}>Not available</div>;
    }

    if (Array.isArray(props.clients) && props.clients.length === 0) {
      return <div style={{ color: '#999' }}>---</div>;
    }

    if (Array.isArray(props.clients)) {
      const clientsText = props.clients.join(', ');
      return (
        <div
          className='clients-cell'
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
          data-pr-tooltip={clientsText}
          data-pr-position='top'
        >
          {clientsText}
          <Tooltip target='.clients-cell' />
        </div>
      );
    }

    return <div>{String(props.clients)}</div>;
  }
  const threeDotsTemplate = (data) => {
    return (
      <div
        onClick={() => {
          if (data.enabled) return data.onClick();
        }}
      >
        <span>
          {data.icon} {data.text}
        </span>
      </div>
    );
  };
  const actions = (props) => {
    const userOwnsTest = isAdmin || props.userOwnsTest;
    return (
      <div className='d-flex'>
        <div>
          {props.isScheduled && <ChildExecutions id={props.id} />}
          <See
            testId={props.id}
            testStatus={props.status}
            seeTestResultsHandler={seeTestResultsHandler}
          />
          <Favorites
            testId={props.id}
            isFavorite={props.isFavourite}
            userOwnsTest={isAdmin || props.userOwnsTest}
            addToFavoritesHandler={addToFavoritesHandler}
            removeFromFavoritesHandler={removeFromFavoritesHandler}
          />
          <Cancel
            testId={props.id}
            testStatus={props.status}
            userOwnsTest={isAdmin || props.userOwnsTest}
            cancelExecutionHandler={cancelExecutionHandler}
          />

          <Rerun
            testId={props.id}
            testStatus={props.status}
            testName={props.name}
            rerunSingleClickHandler={rerunSingleClickHandler}
          />
        </div>
        <OtherOptionsMenu
          deleteSingleClickHandler={deleteSingleClickHandler}
          editRoute={editRoute}
          isATCTable={isATCTable}
          props={props}
          roles={roles}
          scheduleSingleClickHandler={scheduleSingleClickHandler}
          userOwnsTest={userOwnsTest}
          isAdmin={isAdmin}
          threeDotsTemplate={threeDotsTemplate}
        />
      </div>
    );
  };

  //Filter templates
  const envFilterTemplate = (options) => {
    return (
      <Dropdown
        placeholder='Filter by env'
        value={options.value}
        options={ENVIRONMENTS}
        optionLabel='text'
        optionValue='value'
        onChange={(e) => options.filterApplyCallback(e.value)}
        showClear={true}
      />
    );
  };

  const statusFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={URL_STATUS}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder='Filter by status'
        style={{ minWidth: '8rem' }}
        showClear={true}
      />
    );
  };
  const testResultsFilterTemplate = (options) => {
    return (
      <Dropdown
        placeholder='Filter by test results'
        value={options.value}
        options={['PASSED', 'FAILED']}
        onChange={(e) => options.filterApplyCallback(e.value)}
        popupWidth='150px'
        width='250px'
        showClear={true}
      />
    );
  };
  const regionTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        placeholder='Filter by region'
        options={REGIONS_DATASOURCE_UNDERSCORE}
        optionLabel='text'
        optionValue='value'
        onChange={(e) => options.filterApplyCallback(e.value)}
        popupWidth='200px'
        showClear={true}
      />
    );
  };

  const actionsFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        placeholder={'Filter favorites executions'}
        options={FAVORITES_FILTER}
        optionLabel='text'
        optionValue='value'
        onChange={(e) => {
          options.filterApplyCallback(e.value);
        }}
        showClear={true}
      />
    );
  };

  // Query for dropwdown
  const { data: customersData, loading: clientsLoading } = useQuery(
    GET_CUSTOMERS_DATA,
    {
      fetchPolicy: 'cache-first',
    }
  );
  // Filter template
  const clientsFilterTemplate = (options) => {
    const customerCodes =
      customersData?.customerFindMany
        ?.map((customer) => customer.code)
        .sort() || [];

    if (clientsLoading) {
      return (
        <Dropdown
          value={options.value}
          placeholder='Select client'
          options={[
            { label: 'Loading clients...', value: null, disabled: true },
          ]}
          optionLabel='label'
          optionValue='value'
          onChange={(e) => options.filterApplyCallback(e.value)}
          showClear={true}
          style={{ minWidth: '8rem' }}
        />
      );
    }

    return (
      <Dropdown
        value={options.value}
        placeholder={`Filter by client (${customerCodes.length})`}
        options={customerCodes}
        onChange={(e) => options.filterApplyCallback(e.value)}
        showClear={true}
        style={{ minWidth: '8rem' }}
      />
    );
  };

  function sortComparer(reference, comparer) {
    const ref_date = new Date(reference);
    const comparer_date = new Date(comparer);
    if (ref_date < comparer_date) {
      return -1;
    }
    if (ref_date > comparer_date) {
      return 1;
    }
    return 0;
  }

  const onChangePage = (args) => {
    setFirst(args.first);
    refetch({
      page: args.page + 1,
      perPage: perPage,
    });
  };

  let _actionsTemplate = actions;

  const [first, setFirst] = useState(1);
  return (
    <div className='card'>
      <DataTable
        value={data}
        className='test-executions-datatable'
        filters={filters}
        filterDisplay='row'
        onFilter={(args) => {
          let _filter = { ...refetchVariables.filter };
          Object.entries(args.filters).forEach(([key, value]) => {
            if (value.value) {
              if (key === 'clients') {
                _filter['filters'] = [
                  { field: 'client', values: [value.value] },
                ];
              } else {
                _filter[FILTER_NAME_TO_PARAM[key]] = value.value;
              }
            }
          });
          refetch({
            ...refetchVariables,
            filter: _filter,
          });
        }}
        rows={10}
        size='normal'
      >
        <Column field='id' header='Id' isPrimaryKey hidden={true} />
        {isScheduled && <Column field='checkbox' header='Scheduled' />}
        <Column
          field='executionStatus'
          header='Test Result'
          body={testResultsTemplate}
          filter
          filterPlaceholder='Search by test result'
          filterElement={testResultsFilterTemplate}
          showFilterMenu={false}
          showClearButton={false}
        />
        <Column
          field='email'
          header='User'
          allowFiltering={false}
          allowSorting={false}
        />
        <Column
          field='env'
          header='Env'
          filter={true}
          filterElement={envFilterTemplate}
          showFilterMenu={false}
          allowSorting={false}
          showClearButton={false}
        />
        <Column
          field='clients'
          header='Clients'
          body={clientsTemplate}
          filter
          filterElement={clientsFilterTemplate}
          showFilterMenu={false}
          showClearButton={false}
          allowSorting={false}
          style={{ maxWidth: '8rem' }}
        />
        {!isATCTable && (
          <Column
            field='region'
            header='Region'
            filter={true}
            filterElement={regionTemplate}
            showFilterMenu={false}
            style={{ maxWidth: '7rem' }}
            showClearButton={false}
          />
        )}
        <Column
          field='date'
          header='Date'
          allowFiltering={false}
          allowSorting={true}
          sortComparer={sortComparer}
        />
        <Column
          field='name'
          header='Test Name'
          filter={true}
          filterPlaceholder='Search by name'
          body={nameTemplate}
          showClearButton={false}
          showFilterMenu={false}
        />
        <Column
          field='status'
          header='Status'
          allowFiltering
          allowSorting={false}
          filterElement={statusFilterTemplate}
          filter={true}
          showFilterMenu={false}
          style={{ maxWidth: '9rem' }}
          showClearButton={false}
        />
        <Column
          field='failed_total'
          header='Failed/Total'
          allowFiltering={false}
          allowSorting={false}
          style={{ maxWidth: '4rem' }}
        />
        <Column
          field='duration'
          header='Duration'
          allowFiltering={false}
          allowSorting={false}
        />
        <Column
          field='isFavourite'
          header='Actions'
          allowSorting={false}
          showFilterMenu={false}
          body={_actionsTemplate}
          filter={true}
          filterElement={actionsFilterTemplate}
          style={{ maxWidth: '12rem' }}
          showClearButton={false}
        />
      </DataTable>
      {itemCount > 0 && (
        <Paginator
          first={first}
          rows={10}
          totalRecords={itemCount}
          onPageChange={(args) => onChangePage(args)}
        />
      )}
    </div>
  );
}
export default TestExecutionsTable;
